import { i18n } from '@/plugins/i18n'

export const pspRequestStatus = {
    SUCCESS: 1,
    FAIL: 0,
    PENDING: 2,
    END: 3,
}

export const pspRequestStatusStr = {
    SUCCESS: i18n.t('psp_request_status.success'),
    FAIL: i18n.t('psp_request_status.fail'),
    PENDING: i18n.t('psp_request_status.pending'),
    END: i18n.t('psp_request_status.end'),
    get(status) {
        let status_str = null;
        Object.keys(pspRequestStatus).forEach(function (item, index) {
            if(pspRequestStatus[item] === status) {
                status_str = pspRequestStatusStr[item]
            }
        })

        return status_str
    }
}

export const pspRequestVariant = (status) => {
    return (status === pspRequestStatus.SUCCESS || status === pspRequestStatus.END)
        ? 'success' 
        : (
            (status === pspRequestStatus.PENDING)
            ? 'warning'
            : 'danger'
        )
}



export const pspName = {
    mellat: 'mellat',
    novin: 'novin',
    saman: 'saman',
    parsian: 'parsian',
    pasargad: 'pasargad',
}

export const pspNameStr = {
    mellat: i18n.t('psp_list.mellat'),
    novin: i18n.t('psp_list.novin'),
    saman: i18n.t('psp_list.saman'),
    parsian: i18n.t('psp_list.parsian'),
    pasargad: i18n.t('psp_list.pasargad'),
    get(psp) {
        let psp_str = null;
        Object.keys(pspName).forEach(function (item, index) {
            if(pspName[item] === psp) {
                psp_str = pspNameStr[item]
            }
        })

        return psp_str
    }
}

export const pspNameVariant = (psp) => {
    if (psp === pspName.mellat)
        return 'mellat'
    else if (psp === pspName.novin)
        return 'novin'
    else if (psp === pspName.saman)
        return 'saman'
    else if (psp === pspName.parsian)
        return 'parsian'
    else if (psp === pspName.pasargad)
        return 'pasargad'
    return ''
}
